import React from 'react';
import cx from 'classnames';

import Button from '../../atoms/Button';
import Icon from '../../atoms/Icon';

import styles from './SearchBar.module.scss';
import usePresenter from './SearchBar.presenter';
import getProps from './SearchBar.props';
import { SearchBarCombinedProps } from './types';

const SearchBar: React.FC<SearchBarCombinedProps> = (props) => {
  const {
    className,
    classes,
    textPlaceholder,
    icon,
    button,
    state,
    clearSearch,
    // Input props
    ref,
    textValue,
    onKeyDown,
    onBlur,
    onChange,
    onFocus,
  } = usePresenter(props);

  const variantName = `${state}`;
  const internalProps = getProps(variantName);
  const currentStyle = styles[`searchBar${variantName}`];

  const inputProps = {
    ref,
    value: textValue,
    onKeyDown: onKeyDown,
    onChange,
    onFocus,
  };

  const focusInputOnClick = () => {
    if (!ref || !ref.current) {
      return;
    }

    ref.current.focus();
  };

  let componentView;

  switch (variantName) {
    case 'Filled': {
      componentView = (
        <div
          onClick={focusInputOnClick}
          tabIndex={0} // MANUAL OVERRIDE
          onBlur={onBlur} // MANUAL OVERRIDE
          className={cx(currentStyle, className)}
        >
          <Icon
            className={cx(styles.icon, classes?.icon)}
            {...internalProps.icon}
            {...icon}
          />
          <input
            className={cx(styles.input, classes?.input)}
            placeholder={textPlaceholder}
            {...inputProps}
          />
          <Button
            className={cx(styles.button, classes?.button)}
            {...internalProps.button}
            {...button}
            onClick={clearSearch}
          />
        </div>
      );
      break;
    }
    case 'Unfilled': {
      componentView = (
        <div
          onClick={focusInputOnClick}
          className={cx(currentStyle, className)}
        >
          <Icon
            className={cx(styles.icon, classes?.icon)}
            {...internalProps.icon}
            {...icon}
          />
          <input
            className={cx(styles.input, classes?.input)}
            placeholder={textPlaceholder}
            {...inputProps}
          />
        </div>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
};

export default SearchBar;
